'use strict';exports.__esModule = true;var _validate = require('../../utils/validate');

var validate = function validate(values) {
  var errors = {};

  if (!values.name) {
    errors.name = 'emptyField';
  }

  if (!values.phone_number) {
    errors.phone_number = 'emptyField';
  }

  if (values.email && !(0, _validate.emailRegexValidation)(values.email)) {
    errors.email = 'wrongEmail';
  }

  return errors;
};exports.default =

validate;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/RealtorLandingContactForm/validate.js
// module id = 1252
// module chunks = 0